// French translations
const fr = {
  translation: {
    // Common
    'app.name': 'Surveillance à Distance',
    'app.login': 'Connexion',
    'app.loginDemo': 'Démo Connexion',
    'app.register': 'Inscription',
    'app.logout': 'Déconnexion',
    'common.dashboard': 'Tableau de Bord',
    'common.installations': 'Liste Installations',
    'app.news': 'Actualités',
    'news.overview': 'Aperçu Actualités',
    'news.searchPlaceholder': 'Rechercher des actualités...',
    'news.searchButton': 'Rechercher',
    'news.noNewsFound': 'Aucune actualité trouvée.',
    'app.shop': 'Boutique',

    // Gallery
    'gallery.title': 'Galerie Installations',
    'gallery.share': 'Partager',
    'gallery.shared': 'Partagé',
    'gallery.pending': 'En Attente',
    'gallery.noImages': 'Aucune image disponible',
    'gallery.like': 'J\'aime',
    'gallery.loginToLike': 'Connectez-vous pour aimer',
    'gallery.loadError': 'Échec chargement galerie',
    'common.uploadImagesSuccess': 'Téléchargement réussi',
    'common.uploadImagesFailed': 'Échec téléchargement',
    'gallery.deleteConfirm': 'Supprimer cette image ?',
    'gallery.maxImages': 'Max {{max}} images autorisées',
    'gallery.caption': 'Description image',
    'gallery.selectInstallation': 'Sélectionner installation',
    'gallery.selectFiles': 'Sélectionner fichiers',
    'gallery.filesSelected': '{{count}} fichiers sélectionnés',
    'gallery.selectInstallationAndFiles': 'Veuillez sélectionner installation et fichiers',
    'gallery.shareToGallery': 'Partager dans galerie publique',
    'gallery.myImages': 'Mes Images',
    'gallery.publicGallery': 'Galerie Publique',
    'gallery.unshare': 'Annuler partage',
    'gallery.unshared': 'Partage annulé',
    'gallery.subtitle': 'Partagez votre installation solaire et inspirez les autres',
    'gallery.dropOrClick': 'Glissez images ici ou cliquez',
    'gallery.private': 'Privé',
    'gallery.selectSource': 'Sélectionner source',
    'gallery.takePhoto': 'Prendre Photo',
    'gallery.chooseFromGallery': 'Choisir Galerie',
    'gallery.captionPlaceholder': 'Décrivez votre installation...',
    'gallery.shareHint': 'Autoriser autres utilisateurs à voir',
    'common.uploadImagesHint': 'Formats JPG, PNG (max 10Mo)',

    'common.devices': 'Appareils',
    'app.profile': 'Profil',
    'common.settings': 'Paramètres',
    'settings.verificationCode': 'Code de vérification',
    'settings.sendCode': 'Envoyer le code',
    'settings.codeSentNotice': 'Code de vérification envoyé à votre e-mail',
    'settings.codeRequired': 'Veuillez saisir le code de vérification à 6 chiffres',
    'app.language': 'Langue',

    'app.email': 'Email',
    'common.password': 'Mot de Passe',
    'app.username': 'Nom d\'Utilisateur',
    'app.confirmPassword': 'Confirmer MDP',
    'app.submit': 'Valider',
    'common.cancel': 'Annuler',
    'common.save': 'Enregistrer',
    'common.set': 'Écrire',
    'common.delete': 'Supprimer',
    'common.add': 'Ajouter',
    'common.upload': 'Télécharger',
    'common.edit': 'Modifier',
    'common.search': 'Rechercher',
    'common.filter': 'Filtrer',
    'common.sort': 'Trier',
    'common.status': 'Statut',
    'common.online': 'En Ligne',
    'common.offline': 'Hors Ligne',
    'common.error': 'Erreur',
    'common.success': 'Succès',
    'app.back': 'Retour',
    'app.home': 'Accueil',
    'common.actions': 'Actions',
    'common.loading': 'Chargement...',
    'common.processing': 'Traitement...',
    'common.close': 'Fermer',
    'common.units': 'Unités',
    'common.normal': 'Normal',
    'common.tooHigh': 'Trop Élevé',
    'common.tooLow': 'Trop Bas',
    'common.number': 'Numéro',
    'common.time': 'Heure',
    'common.overview': 'Aperçu',
    'common.details': 'Détails',
    'common.rowsPerPage': 'Lignes/page',
    'common.readMore': 'Lire la suite',
    // Unified terms
    'common.voltage': 'Tension',
    'common.current': 'Courant',
    'common.power': 'Puissance',
    'common.temperature': 'Température',
    'common.soc': 'SOC',
    'common.charging': 'Charge',
    'common.discharging': 'Décharge',
    'common.idle': 'Veille',
    'common.warning': 'Avertissement',
    'common.warnState1': 'Avertiss. État 1',
    'common.warnState2': 'Avertiss. État 2',
    'common.cell': 'Cellule',
    'common.avgVoltage': 'Tension Moy.',
    'common.avgTemperature': 'Temp. Moy.',
    'common.totalCurrent': 'Courant Total',
    'common.totalPower': 'Puissance Totale',
    'common.fullyCharged': 'Pleine Charge',
    'common.user': 'Utilisateur',
    'common.deviceId': 'ID Appareil',
    'common.unknownWarning': 'Avert. Inconnu',
    'common.admin': 'Admin',
    'common.protection': 'Protection',
    'common.fault': 'Défaut',
    'common.calibration': 'Calibration',
    'common.refresh': 'Actualiser',
    'common.addDevice': 'Ajouter Appareil',
    'common.deviceAdded': 'Appareil ajouté avec succès',
    'common.cycleCount': 'Cycles',
    'common.soh': 'SOH',
    'common.realtime': 'Surv. Temps Réel',
    'common.batteryPackTitle': 'Pack Batterie #{{index}}',
    'common.remainCapacityAh': 'Capacité Restante (Ah)',
    'common.fullChargeCapacityAh': 'Capacité Totale (Ah)',
    'common.designCapacityAh': 'Capacité Nom. (Ah)',
    'common.backToDetail': 'Retour Détails Install.',
    'common.loadDeviceFailed': 'Échec chargement appareil',
    'common.permissionsManagement': 'Gestion Permissions',
    'common.shortCircuitProt': 'Prot. Court-Circuit',
    'common.startDate': 'Date Début',
    'common.endDate': 'Date Fin',
    // Status & States
    'common.expired': 'Expiré',
    // Actions
    'common.create': 'Créer',
    // Time-related
    'common.day': 'jour',
    'common.days': 'jours',
    'common.createdAt': 'Créé Le',
    'common.expiry': 'Date Exp.',
    'common.expiryDays': 'Validité (jours)',
    // Battery-related
    'common.batteryPack': 'Pack Batterie',
    'common.dischargeEnabled': 'Décharge Activ.',
    'common.chargeEnabled': 'Charge Activ.',
    'common.currentLimit': 'Limite Courant',
    'common.charger': 'Chargeur',
    'common.avg': 'Moy.',

    // Device
    'device.lastConnection': 'Dernière Conn.',
    'device.delete': 'Supprimer Install.',
    'device.view': 'Voir Appareil',
    'device.notFound': 'Appareil introuvable',
    'device.deleteSuccess': 'Installation supprimée',
    'device.confirmDelete': 'Supprimer cette installation ?',
    'device.info': 'Infos Installation',
    'device.details': 'Détails Appareil',
    'device.never': 'Jamais',
    'device.errorMissingFields': 'Remplissez tous les champs obligatoires',
    'device.idHelp': 'Entrez un ID unique pour votre appareil',
    'device.nameHelp': 'Donnez un nom à votre appareil',
    'device.loading': 'Chargement appareils...',
    'common.justNow': 'À l\'instant',
    'device.minutesAgo': 'minutes',
    'device.hoursAgo': 'heures',
    'device.noDevicesDesc': 'Vous n\'avez ajouté aucun appareil. Cliquez ci-dessous pour ajouter votre premier appareil.',
    'device.deleting': 'Suppression...',
    'device.noConnections': 'Aucune connexion récente',
    'device.type': 'Type Appareil',
    'device.optionalInfo': 'Infos Optionnelles',
    'device.optionalInfoTooltip': 'Ces informations nous aident à fournir un meilleur service après-vente',
    'device.inverterBrand': 'Marque Onduleur',
    'device.inverterModel': 'Modèle Onduleur',
    'device.solarPower': 'Puis. Solaire (kW)',
    'device.city': 'Ville Installation',
    'device.description': 'Descr. Installation',
    'device.updatedAt': 'Mise à Jour',

    // Battery data
    'battery.status': 'État Charge',
    'battery.data': 'Données Batterie',
    'battery.history': 'Historique',
    'battery.protectionRecord': 'Registre Protections',
    'battery.balance': 'Courant Équil.',
    'battery.cells': 'Nb Cellules',
    'battery.noData': 'Aucune donnée',
    'battery.historyCharts': 'Graphiques Historique',
    'battery.resetZoom': 'Réinitialiser',

    'battery.cellData': 'Données Cellules',
    'battery.cellVoltageData': 'Tension Cellules',
    'battery.temperatureData': 'Données Température',
    'battery.cellDataUnavailable': 'Données cellules temp. indisponibles, affichage données précédentes...',
    'battery.tempDataUnavailable': 'Données capteurs temp. temp. indisponibles, affichage données précédentes...',
    'battery.cellVoltageTable': 'Tableau Tensions',
    'battery.tempDataTable': 'Tableau Températures',
    'battery.cellStats': 'Stats Cellules',
    'battery.activeBalancing': 'Équilibrage Actif',
    'battery.activeBalancingOn': 'Équilibrage',
    'battery.heaterEnabled': 'Chauffage Activ.',
    'battery.currentLimitEnabled': 'Limite Courant Activ.',
    'battery.highest': 'Max',
    'battery.lowest': 'Min',
    'battery.highestVoltage': 'Tension Max',
    'battery.lowestVoltage': 'Tension Min',
    'battery.volDiff': 'Diff. Tension',
    'battery.totalCells': 'Cellules Totales',
    'battery.temperatureSensors': 'Capteurs Temp.',
    'battery.temperatureStats': 'Stats Température',
    'battery.sensorCount': 'Nb Capteurs',
    'battery.highestTemperature': 'Temp. Max',
    'battery.lowestTemperature': 'Temp. Min',
    'battery.faultState': 'État Défaut',
    'battery.protectState1': 'État Protection 1',
    'battery.protectState2': 'État Protection 2',

    // Warning titles
    'warning.title': 'Infos Avertissements',
    'warning.current': 'Avertissements Actuels',
    'warning.normal': 'État batterie normal, aucun avertissement',
    'warning.noWarning': 'Aucun Avert.',

    // Warning states

    // Protection state related
    'warning.protect_high_discharge_current': 'Protection Surcharge Déch.',
    'warning.protect_high_charge_current': 'Protection Surcharge Ch.',
    'warning.protect_low_total_voltage': 'Protection Sous-tension Totale',
    'warning.protect_high_total_voltage': 'Protection Surtension Totale',
    'warning.protect_low_cell_voltage': 'Protection Sous-tension Cell.',
    'warning.protect_high_cell_voltage': 'Protection Surtension Cell.',
    'warning.protect_low_env_temp': 'Protection Temp. Amb. Basse',
    'warning.protect_high_env_temp': 'Protection Temp. Amb. Haute',
    'warning.protect_high_mos_temp': 'Protection Temp. MOS Haute',
    'warning.protect_low_discharge_temp': 'Protection Temp. Déch. Basse',
    'warning.protect_low_charge_temp': 'Protection Temp. Ch. Basse',
    'warning.protect_high_discharge_temp': 'Protection Temp. Déch. Haute',
    'warning.protect_high_charge_temp': 'Protection Temp. Ch. Haute',

    // Command state related
    'battery.reverse_connected': 'Inversion Connexion Batt.',

    // Fault state related
    'warning.fault_sampling': 'Défaut Échantillonnage',
    'warning.fault_cell': 'Défaut Cellule',
    'warning.fault_ntc': 'Défaut Capteur Temp.',
    'warning.fault_discharge_mos': 'Défaut MOS Décharge',
    'warning.fault_charge_mos': 'Défaut MOS Charge',
    'warning.fault_adapter_temp': 'Surchauffe Carte Adapt.',
    'warning.fault_virtual_connection': 'Connexion Virtuelle Batt.',
    'warning.fault_communication': 'Défaut Communication',
    'warning.fault_ccb': 'Défaut CCB',
    'warning.fault_heater': 'Défaut Chauffage',
    'warning.fault_12v': 'Défaut Alim. 12V',
    'warning.fault_total_voltage': 'Défaut Tension Totale',
    'warning.fault_temp_diff': 'Défaut Diff. Temp.',
    'warning.fault_detect_resistor': 'Défaut Résist. Détect.',
    'warning.fault_trip_unit': 'Défaut Déclencheur',
    'warning.fault_master_slave': 'Défaut Comm. Maître/Esclave',
    'warning.fault_bms_lock': 'BMS Verrouillé',
    'warning.fault_mcu_overvoltage': 'Surtension MCU',

    'warning.protect_short_circuit': 'Protection Court-Circuit',
    'warning.protect_charger_overvoltage': 'Protection Surtension Char.',
    'warning.protect_full_charge': 'Protection Pleine Charge',

    // Status indicators
    'status.limit_current_on': 'Limite Courant ON',
    'status.limit_current_off': 'Limite Courant OFF',
    'status.charge_mos_on': 'MOS Charge ON',
    'status.charge_mos_off': 'MOS Charge OFF',
    'status.discharge_mos_on': 'MOS Déch. ON',
    'status.discharge_mos_off': 'MOS Déch. OFF',
    'status.charger_connected': 'Chargeur Connecté',
    'status.charger_disconnected': 'Chargeur Déconnecté',
    'status.heater_on': 'Chauffage ON',
    'status.heater_off': 'Chauffage OFF',

    // Warning state 1 related
    'warning.warn_high_discharge_current': 'Avert. Courant Déch. Élevé',
    'warning.warn_high_charge_current': 'Avert. Courant Ch. Élevé',
    'warning.warn_low_total_voltage': 'Avert. Tension Totale Basse',
    'warning.warn_high_total_voltage': 'Avert. Tension Totale Haute',
    'warning.warn_low_cell_voltage': 'Avert. Tension Cell. Basse',
    'warning.warn_high_cell_voltage': 'Avert. Tension Cell. Haute',

    // Warning state 2 related
    'warning.warn_low_soc': 'Avert. SOC Bas',
    'warning.warn_high_mos_temp': 'Avert. Temp. MOS Haute',
    'warning.warn_low_env_temp': 'Avert. Temp. Amb. Basse',
    'warning.warn_high_env_temp': 'Avert. Temp. Amb. Haute',
    'warning.warn_low_discharge_temp': 'Avert. Temp. Déch. Basse',
    'warning.warn_low_charge_temp': 'Avert. Temp. Ch. Basse',
    'warning.warn_high_discharge_temp': 'Avert. Temp. Déch. Haute',
    'warning.warn_high_charge_temp': 'Avert. Temp. Ch. Haute',

    // Warning states
    'warning.below_lower_limit': 'Sous Limite Inf.',
    'warning.above_upper_limit': 'Au-dessus Limite Sup.',
    'warning.user_defined': 'Avert. Défini Utilis.',
    'warning.other_fault': 'Autre Défaut',

    // Warning descriptions (complete translation)
    'warningDesc.warn_low_soc': 'Le SOC de la batterie est sous le seuil de sécurité, veuillez charger dès que possible',
    'warningDesc.warn_high_mos_temp': 'La température MOS est trop élevée, cela peut affecter l\'efficacité de charge/décharge',
    'warningDesc.warn_low_env_temp': 'La température ambiante est trop basse, cela peut affecter les performances de la batterie',
    'warningDesc.warn_high_env_temp': 'La température ambiante est trop élevée, veuillez surveiller la dissipation thermique',
    'warningDesc.warn_low_discharge_temp': 'La température de décharge est trop basse, la décharge a été limitée',
    'warningDesc.warn_low_charge_temp': 'La température de charge est trop basse, la charge a été limitée',
    'warningDesc.warn_high_discharge_temp': 'La température de décharge est trop élevée, la décharge a été limitée',
    'warningDesc.warn_high_charge_temp': 'La température de charge est trop élevée, la charge a été limitée',
    'warningDesc.warn_high_discharge_current': 'Le courant de décharge dépasse la limite de sécurité',
    'warningDesc.warn_high_charge_current': 'Le courant de charge dépasse la limite de sécurité',
    'warningDesc.warn_low_total_voltage': 'La tension totale est sous le seuil de sécurité',
    'warningDesc.warn_high_total_voltage': 'La tension totale est au-dessus du seuil de sécurité',
    'warningDesc.warn_low_cell_voltage': 'La tension de cellule est trop basse',
    'warningDesc.warn_high_cell_voltage': 'La tension de cellule est trop élevée',
    'warningDesc.protect_high_discharge_current': 'Le courant de décharge est trop élevé, protection déclenchée',
    'warningDesc.protect_high_charge_current': 'Le courant de charge est trop élevé, protection déclenchée',
    'warningDesc.protect_short_circuit': 'Court-circuit détecté, protection déclenchée',
    'warningDesc.protect_low_total_voltage': 'La tension totale est trop basse, protection déclenchée',
    'warningDesc.protect_high_total_voltage': 'La tension totale est trop élevée, protection déclenchée',
    'warningDesc.protect_low_cell_voltage': 'La tension de cellule est trop basse, protection déclenchée',
    'warningDesc.protect_high_cell_voltage': 'La tension de cellule est trop élevée, protection déclenchée',
    'warningDesc.protect_low_env_temp': 'La température ambiante est trop basse, protection déclenchée',
    'warningDesc.protect_high_env_temp': 'La température ambiante est trop élevée, protection déclenchée',
    'warningDesc.protect_high_mos_temp': 'La température MOS est trop élevée, protection déclenchée',
    'warningDesc.protect_low_discharge_temp': 'La température de décharge est trop basse, protection déclenchée',
    'warningDesc.protect_low_charge_temp': 'La température de charge est trop basse, protection déclenchée',
    'warningDesc.protect_high_discharge_temp': 'La température de décharge est trop élevée, protection déclenchée',
    'warningDesc.protect_high_charge_temp': 'La température de charge est trop élevée, protection déclenchée',
    'warningDesc.fault_sampling': 'Le circuit d\'échantillonnage de la batterie est anormal, veuillez vérifier le matériel',
    'warningDesc.fault_cell': 'Défaut de cellule de batterie, veuillez vérifier le pack batterie',
    'warningDesc.fault_ntc': 'Défaut du capteur de température, impossible de mesurer précisément la température',
    'warningDesc.fault_discharge_mos': 'Défaut MOS de décharge, impossible de décharger normalement',
    'warningDesc.fault_charge_mos': 'Défaut MOS de charge, impossible de charger normalement',
    'warningDesc.fault_adapter_temp': 'La température de la carte adaptateur est trop élevée',
    'warningDesc.fault_virtual_connection': 'Le contact de la batterie est mauvais, veuillez vérifier la connexion',

    // Charging status constants

    // Authentication
    'auth.loginTitle': 'Connexion à votre compte',
    'auth.registerTitle': 'Créer un nouveau compte',
    'auth.forgotPassword': 'Mot de passe oublié ?',
    'auth.noAccount': 'Pas de compte ?',
    'auth.haveAccount': 'Déjà un compte ?',
    'auth.loginSuccess': 'Connexion réussie',
    'auth.registerSuccess': 'Inscription réussie',
    'auth.registerFailed': 'Échec inscription',
    'auth.logoutSuccess': 'Déconnexion réussie',
    'auth.invalidCredentials': 'Email ou mot de passe invalide',
    'auth.passwordMismatch': 'Les mots de passe ne correspondent pas',
    'auth.emailExists': 'Cet email existe déjà',
    'auth.usernameExists': 'Ce nom d\'utilisateur existe déjà',
    'auth.managerEmail': 'Email admin (optionnel)',
    'auth.managerEmailHelp': 'Si vous connaissez l\'email de votre admin, entrez-le ici pour rejoindre son équipe',
    'auth.invitationCode': 'Code d\'invitation (optionnel)',
    'auth.invitationCodeHelp': 'Si vous avez un code d\'invitation, entrez-le ici',
    'auth.forgotPasswordDesc': 'Veuillez entrer votre adresse email enregistrée et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    'auth.forgotPasswordSuccess': 'Email de réinitialisation envoyé. Vérifiez votre boîte de réception.',
    'auth.invalidToken': 'Token Invalide',
    'auth.tokenErrorDesc': 'Token de réinitialisation invalide ou manquant. Veuillez accéder à cette page depuis votre lien email.',
    'auth.passwordUpdated': 'Mot de passe réinitialisé avec succès. Redirection vers la connexion...',
    'auth.resetPasswordTitle': 'Réinitialiser Mot de Passe',

    // Settings
    'settings.about': 'À Propos',
    'settings.aboutDesc': 'Home Battery IoT est un système de surveillance de batteries domestiques.',
    'settings.languageUpdated': 'Langue mise à jour avec succès',
    'settings.updateFailed': 'Échec mise à jour paramètres',
    'settings.changePassword': 'Changer Mot de Passe',
    'settings.currentPassword': 'Mot de Passe Actuel',
    'settings.newPassword': 'Nouveau Mot de Passe',
    'settings.confirmPassword': 'Confirmer Nouveau MDP',
    'settings.passwordUpdated': 'Mot de passe changé avec succès',
    'settings.passwordMismatch': 'Les mots de passe ne correspondent pas',
    'settings.passwordTooShort': 'Le mot de passe doit contenir au moins 6 caractères',
    'settings.usernameUpdated': 'Nom d\'utilisateur mis à jour',
    'settings.appearance': 'Paramètres Apparence',
    'settings.avatar': 'Avatar',
    'settings.changeAvatar': 'Changer Avatar',
    'settings.avatarHint': 'Max 2Mo, formats JPG/PNG/GIF/WebP',
    'settings.avatarUpdated': 'Avatar mis à jour',
    'settings.invalidFileType': 'Veuillez sélectionner une image',
    'settings.fileTooLarge': 'Fichier trop volumineux, max 2Mo',
    'settings.timezone': 'Fuseau Horaire',
    'settings.timezoneUpdated': 'Fuseau horaire mis à jour',

    // Timezone labels
    'timezones.UTC': 'UTC (Temps Universel Coordonné)',
    'timezones.Europe/London': 'Londres (GMT/BST)',
    'timezones.Europe/Dublin': 'Dublin (GMT/IST)',
    'timezones.Europe/Paris': 'Paris (CET/CEST)',
    'timezones.Europe/Berlin': 'Berlin (CET/CEST)',
    'timezones.Europe/Amsterdam': 'Amsterdam (CET/CEST)',
    'timezones.Europe/Brussels': 'Bruxelles (CET/CEST)',
    'timezones.Europe/Rome': 'Rome (CET/CEST)',
    'timezones.Europe/Madrid': 'Madrid (CET/CEST)',
    'timezones.Europe/Lisbon': 'Lisbonne (WET/WEST)',
    'timezones.Europe/Vienna': 'Vienne (CET/CEST)',
    'timezones.Europe/Zurich': 'Zurich (CET/CEST)',
    'timezones.Europe/Stockholm': 'Stockholm (CET/CEST)',
    'timezones.Europe/Oslo': 'Oslo (CET/CEST)',
    'timezones.Europe/Copenhagen': 'Copenhague (CET/CEST)',
    'timezones.Europe/Helsinki': 'Helsinki (EET/EEST)',
    'timezones.Europe/Warsaw': 'Varsovie (CET/CEST)',
    'timezones.Europe/Prague': 'Prague (CET/CEST)',
    'timezones.Europe/Athens': 'Athènes (EET/EEST)',
    'timezones.Europe/Istanbul': 'Istanbul (TRT)',
    'timezones.Europe/Moscow': 'Moscou (MSK)',
    'timezones.America/New_York': 'New York (EST/EDT)',
    'timezones.America/Toronto': 'Toronto (EST/EDT)',
    'timezones.America/Chicago': 'Chicago (CST/CDT)',
    'timezones.America/Denver': 'Denver (MST/MDT)',
    'timezones.America/Phoenix': 'Phoenix (MST)',
    'timezones.America/Los_Angeles': 'Los Angeles (PST/PDT)',
    'timezones.America/Vancouver': 'Vancouver (PST/PDT)',
    'timezones.America/Anchorage': 'Anchorage (AKST/AKDT)',
    'timezones.Pacific/Honolulu': 'Honolulu (HST)',
    'timezones.America/Mexico_City': 'Mexico (CST/CDT)',
    'timezones.America/Bogota': 'Bogota (COT)',
    'timezones.America/Lima': 'Lima (PET)',
    'timezones.America/Santiago': 'Santiago (CLT/CLST)',
    'timezones.America/Sao_Paulo': 'Sao Paulo (BRT)',
    'timezones.America/Buenos_Aires': 'Buenos Aires (ART)',
    // Middle East
    'timezones.Asia/Jerusalem': 'Jérusalem (IST)',
    'timezones.Asia/Beirut': 'Beyrouth (EET/EEST)',
    'timezones.Asia/Amman': 'Amman (EET/EEST)',
    'timezones.Asia/Baghdad': 'Bagdad (AST)',
    'timezones.Asia/Kuwait': 'Koweït (AST)',
    'timezones.Asia/Dubai': 'Dubaï (GST)',
    'timezones.Asia/Muscat': 'Mascate (GST)',
    'timezones.Asia/Riyadh': 'Riyad (AST)',
    'timezones.Asia/Qatar': 'Doha (AST)',
    'timezones.Asia/Bahrain': 'Bahreïn (AST)',
    'timezones.Asia/Tehran': 'Téhéran (IRST)',
    // Central Asia
    'timezones.Asia/Kabul': 'Kaboul (AFT)',
    'timezones.Asia/Karachi': 'Karachi (PKT)',
    'timezones.Asia/Tashkent': 'Tachkent (UZT)',
    'timezones.Asia/Almaty': 'Almaty (ALMT)',
    // South Asia
    'timezones.Asia/Kolkata': 'Mumbai / New Delhi (IST)',
    'timezones.Asia/Colombo': 'Colombo (IST)',
    'timezones.Asia/Kathmandu': 'Katmandou (NPT)',
    'timezones.Asia/Dhaka': 'Dacca (BST)',
    'timezones.Asia/Yangon': 'Yangon (MMT)',
    // Southeast Asia
    'timezones.Asia/Bangkok': 'Bangkok (ICT)',
    'timezones.Asia/Ho_Chi_Minh': 'Hô Chi Minh-Ville (ICT)',
    'timezones.Asia/Jakarta': 'Jakarta (WIB)',
    'timezones.Asia/Singapore': 'Singapour (SGT)',
    'timezones.Asia/Kuala_Lumpur': 'Kuala Lumpur (MYT)',
    'timezones.Asia/Manila': 'Manille (PHT)',
    // East Asia
    'timezones.Asia/Hong_Kong': 'Hong Kong (HKT)',
    'timezones.Asia/Shanghai': 'Shanghai / Pékin (CST)',
    'timezones.Asia/Taipei': 'Taipei (CST)',
    'timezones.Asia/Seoul': 'Séoul (KST)',
    'timezones.Asia/Tokyo': 'Tokyo (JST)',
    // Oceania
    'timezones.Australia/Perth': 'Perth (AWST)',
    'timezones.Australia/Adelaide': 'Adélaïde (ACST/ACDT)',
    'timezones.Australia/Brisbane': 'Brisbane (AEST)',
    'timezones.Australia/Sydney': 'Sydney (AEST/AEDT)',
    'timezones.Australia/Melbourne': 'Melbourne (AEST/AEDT)',
    'timezones.Pacific/Auckland': 'Auckland (NZST/NZDT)',
    // Africa (North)
    'timezones.Africa/Casablanca': 'Casablanca (WET/WEST)',
    'timezones.Africa/Algiers': 'Alger (CET)',
    'timezones.Africa/Tunis': 'Tunis (CET)',
    'timezones.Africa/Tripoli': 'Tripoli (EET)',
    'timezones.Africa/Cairo': 'Le Caire (EET)',
    // Africa (East)
    'timezones.Africa/Khartoum': 'Khartoum (CAT)',
    'timezones.Africa/Addis_Ababa': 'Addis-Abeba (EAT)',
    'timezones.Africa/Nairobi': 'Nairobi (EAT)',
    // Africa (West)
    'timezones.Africa/Lagos': 'Lagos (WAT)',
    'timezones.Africa/Accra': 'Accra (GMT)',
    // Africa (South)
    'timezones.Africa/Johannesburg': 'Johannesburg (SAST)',
    'timezones.Africa/Cape_Town': 'Le Cap (SAST)',

    'common.uploading': 'Téléchargement...',

    // Errors
    'error.pageNotFound': 'Page Non Trouvée',
    'error.pageNotFoundDesc': 'La page recherchée a peut-être été supprimée, renommée ou est temporairement indisponible.',
    'error.fetchFailed': 'Échec récupération données',
    'error.createFailed': 'Échec création',
    'error.copyFailed': 'Échec copie',
    'error.processFailed': 'Échec traitement requête',

    // Admin
    'admin.dashboard': 'Tableau de Bord Admin',
    'admin.superDashboard': 'Tableau de Bord Superadmin',
    'admin.managedUsers': 'Utilisateurs Gérés',
    'admin.managedDevices': 'Appareils Gérés',
    'admin.role': 'Rôle',
    'admin.superadmin': 'Superadmin',
    'admin.noUsers': 'Aucun utilisateur trouvé',
    'admin.userList': 'Liste Utilisateurs',
    'admin.adminList': 'Liste Admins',
    'admin.deviceList': 'Liste Appareils',
    'admin.noAdmins': 'Aucun admin trouvé',
    'admin.addAdmin': 'Ajouter Admin',
    'admin.createError': 'Erreur création admin',
    'admin.fillAllFields': 'Veuillez remplir tous les champs',
    'admin.deviceCount': 'Nb Appareils',
    'admin.assignManager': 'Assigner Admin',
    'admin.selectManager': 'Sélectionner Admin',
    'admin.noManager': 'Aucun Admin (désassigner)',
    'admin.assigningUser': 'Assignation utilisateur',
    'admin.assign': 'Assigner',
    'admin.assignError': 'Erreur assignation admin',
    'admin.self': 'Soi',
    'admin.active': 'Actif',
    'admin.used': 'Utilisé',
    'admin.adminPanel': 'Panneau Admin',
    'admin.newsManagement': 'Gestion Actualités',
    'admin.addNews': 'Ajouter Actualité',
    'admin.editNews': 'Modifier Actualité',
    'admin.deleteNews': 'Supprimer Actualité',
    'admin.deleteNewsConfirm': 'Supprimer cette actualité ?',
    'admin.newsTitle': 'Titre',
    'admin.newsSummary': 'Résumé',
    'admin.newsContent': 'Contenu',
    'admin.newsImageUrl': 'URL Image',
    'admin.newsPublished': 'Publié',
    'admin.newsDraft': 'Brouillon',
    'admin.newsStatus': 'Statut',
    'admin.newsCreateSuccess': 'Actualité créée avec succès',
    'admin.newsUpdateSuccess': 'Actualité mise à jour',
    'admin.newsDeleteSuccess': 'Actualité supprimée',

    // Invitation code management
    'admin.invitationManagement': 'Gestion Codes d\'Invitation',
    'admin.createInvitation': 'Créer Invitation',
    'admin.invitationCode': 'Code d\'Invitation',
    'admin.invitationCreated': 'Invitation créée avec succès',
    'admin.copy': 'Copier',
    'admin.codeCopied': 'Code copié dans le presse-papiers',
    'admin.noInvitations': 'Aucune invitation trouvée',

    // Authorization request related
    'user.authRequests': 'Demandes d\'Autorisation',
    'user.authRequestManagement': 'Gestion Demandes Autorisation',
    'user.createAuthRequest': 'Créer Demande Autorisation',
    'user.authCode': 'Code Autorisation',
    'user.authRequestCreated': 'Demande d\'autorisation créée',
    'user.shareAuthLink': 'Partager Lien Autorisation',
    'user.shareAuthLinkHelp': 'Envoyez ce lien à un admin pour l\'autoriser à gérer votre compte',
    'user.linkCopied': 'Lien copié dans le presse-papiers',
    'user.copyLink': 'Copier Lien',
    'user.share': 'Partager',
    'user.shareLink': 'Partager Lien',
    'user.authRequestHelp': 'Créez une demande pour permettre à un admin de gérer votre compte',
    'user.authRequestShareTitle': 'Autorisation Gestion Batteries IoT',
    'user.authRequestShareText': 'Veuillez m\'autoriser comme admin de mon système de batteries',
    'common.noAuthRequests': 'Aucune demande d\'autorisation trouvée',
    'user.pending': 'En Attente',
    'user.accepted': 'Acceptée',
    'user.rejected': 'Refusée',

    'admin.authRequestReview': 'Révision Demande Autorisation',
    'admin.authRequestDetails': 'Détails Demande',
    'admin.authRequestLoadError': 'Échec chargement demandes',
    'admin.requestCode': 'Code Demande',
    'admin.createdBy': 'Créé Par',
    'admin.processedBy': 'Traité Par',
    'admin.processedAt': 'Traité Le',
    'admin.unknownUser': 'Utilisateur Inconnu',
    'admin.accept': 'Accepter',
    'admin.reject': 'Refuser',
    'admin.authRequestAccepted': 'Demande d\'autorisation acceptée',
    'admin.authRequestRejected': 'Demande d\'autorisation refusée',
    'admin.authRequestNotForAdmin': 'La gestion des demandes d\'autorisation concerne uniquement les utilisateurs réguliers. En tant qu\'admin, vous pouvez examiner et traiter les demandes des utilisateurs.',

    // Battery pack details
    'battery.packageDetails': 'Détails Pack Batterie',

    'battery.basicInfo': 'Informations de Base',
    'battery.cellCount': 'Nb Cellules',
    'battery.tempSensorCount': 'Nb Capteurs Temp.',
    'battery.chargeCurrentStatus': 'État Courant Charge',
    'battery.totalVoltageStatus': 'État Tension Totale',
    'battery.dischargeCurrentStatus': 'État Courant Décharge',
    'battery.controlStatus': 'État Contrôle et Commande',
    'battery.instructionState': 'État Instructions',
    'battery.controlState': 'État Contrôle',
    'battery.chargerAvailable': 'Chargeur Disponible',
    'battery.warningStatus': 'État Avert. et Défauts',
    'battery.led_warning': 'Avert. LED',
    'battery.buzzer_warning': 'Avert. Buzzer',
    'battery.freq_shift': 'Changement Fréq.',
    'battery.parallelStatus': 'État Système Batt. Parallèles',
    'battery.parallelCount': 'Nb Batt. Parallèles',
    'battery.avgCycleCount': 'Cycles Moyens',
    'battery.cycleCountUnit': 'cycles',

    'battery.standby': 'Veille',
    'battery.cellVoltage': 'Tension Cellule',
    'battery.batteryPackUnavailable': 'Données pack batterie temp. indisponibles, tentative d\'affichage des dernières données...',
    'battery.normalStatus': 'Ce pack batterie est normal, aucun avertissement ou défaut',
    'battery.warn_high_charge_temp': 'Temp. Charge Élevée',

    // Dashboard new content
    'dashboard.soc': 'SOC',
    'dashboard.voltage': 'Tension Totale',
    'dashboard.current': 'Courant Total',
    'dashboard.temperature': 'Température Max',
    'dashboard.systemStatus': 'État Système',
    'dashboard.totalDevices': 'Total Appareils',
    'dashboard.onlineDevices': 'Appareils En Ligne',
    'dashboard.deviceStatus': 'État Appareil',
    'dashboard.batteryStatus': 'État Batterie',
    'dashboard.powerStatus': 'État Puissance',
    'dashboard.temperatureStatus': 'État Température',
    'dashboard.avgSOC': 'SOC Moyen',
    'dashboard.types': 'Types',
    'dashboard.batteryHistory': 'Historique Batterie',
    'dashboard.voltageHistory': 'Historique Tension',
    'dashboard.currentHistory': 'Historique Courant',
    'dashboard.socHistory': 'Historique SOC',
    'dashboard.temperatureHistory': 'Historique Temp.',
    'dashboard.lastHour': 'Dernière Heure',
    'dashboard.last6Hours': '6 Dernières Heures',
    'dashboard.lastDay': '24 Dernières Heures',
    'dashboard.lastWeek': 'Semaine Dernière',
    'dashboard.lastMonth': 'Mois Dernier',
    'dashboard.batteryDetails': 'Détails Batterie',
    'dashboard.deviceAnalysis': 'Analyse Appareil',
    'dashboard.systemOverview': 'Aperçu Système',
    'dashboard.deviceTypeDistribution': 'Répartition Types Appareils',
    'dashboard.voltageAndCurrentOverview': 'Aperçu Tension et Courant',
    'dashboard.onlinePercentage': '% En Ligne',
    'dashboard.noAlerts': 'Aucun enregistrement d\'alerte',

    // Dashboard page specific
    'dashboard.totalInstallations': 'Total Installations',
    'dashboard.viewAllInstallations': 'Voir Toutes Installations',
    'dashboard.activeInstallations': 'Installations Actives',
    'dashboard.allInstallations': 'Toutes Installations',
    'dashboard.systemAlertsNotices': 'Alertes et Notifications Système',
    'dashboard.deviceOffline': 'Appareil Hors Ligne',
    'dashboard.deviceOfflineDesc': 'L\'appareil {{name}} ({{id}}) est hors ligne. Vérifiez la connexion.',
    'dashboard.deviceAlarm': 'Alerte Appareil',
    'dashboard.deviceAlarmDesc': 'L\'appareil {{name}} ({{id}}) a des alertes actives. Vérifiez son état.',
    'dashboard.systemNormal': 'Système Normal',
    'dashboard.systemNormalDesc': 'Tous les systèmes fonctionnent normalement.',
    'dashboard.latestNews': 'Actualités Produits',

    // InstallationList page
    'installations.loadError': 'Échec chargement installations. Veuillez réessayer plus tard.',
    'installations.noInstallations': 'Aucune installation trouvée.',
    'installations.realtime': 'Temps Réel',
    'installations.oldData': 'Données Anciennes',
    'installations.batteries': 'Batteries',
    'installations.lastUpdate': 'Dernière MàJ',
    'installations.deviceName': 'Nom Install. (optionnel)',
    'installations.deviceNamePlaceholder': 'Mon Système Batterie',
    'installations.deviceNameHelper': 'Donnez un nom convivial à votre appareil',
    'installations.deviceIdRequired': 'ID obligatoire',
    'installations.deviceIdPlaceholder': 'ID sur l\'étiquette WIFI',
    'installations.deviceClaimed': 'Appareil associé avec succès',
    'installations.addFailed': 'Échec ajout appareil',
    'installations.otherType': 'Autre',

    // Installation Detail page
    'detail.backToList': 'Retour Liste',
    'detail.installationDetail': 'Détails Installation',
    'detail.installationName': 'Nom Installation',
    'detail.owner': 'Propriétaire',
    'detail.batteryCount': 'Nb Batteries',
    'detail.realtimeMetrics': 'Métriques Temps Réel',
    'detail.avgSOC': 'SOC Moyen',
    'detail.avgSOH': 'SOH Moyen',
    'detail.maxCellVol': 'Tension Cell. Max',
    'detail.minCellVol': 'Tension Cell. Min',
    'detail.cellVolDiff': 'Diff. Tension Cell.',

    // Battery Detail page
    'battery.packDetail': 'Détails Pack Batterie #{{index}}',

    'battery.packNotFound': 'Données pack batterie introuvables',
    'battery.loadError': 'Échec chargement données batterie',

    // Battery Overview
    'battery.packVoltage': 'Tension Pack',
    'battery.packCurrent': 'Courant Pack',
    'battery.packPower': 'Puissance Pack',
    'battery.chargerConnected': 'Chargeur Connecté',
    'battery.fullEnergy': 'Énergie Totale',
    'battery.remainEnergy': 'Énergie Restante',

    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.on': 'Activé',
    'common.off': 'Désactivé',
    'common.ongoing': 'En Cours',

    // RealTime Monitor
    'battery.cellVoltages': 'Tensions Cellules',
    'battery.temperatures': 'Surveillance Température',

    // History Charts
    'battery.historyTrends': 'Tendances Historique',
    'battery.voltageCurrent': 'Tension & Courant',

    'battery.dragToSelect': 'Glissez pour sélectionner plage horaire',

    'battery.alarmDetails': 'Détails Alarmes',
    'battery.noActiveAlarms': 'Aucune alarme active',
    'battery.sensor': 'Capteur',
    'battery.issue': 'Problème',
    'battery.tempSensorIssues': 'Problèmes Capteurs Temp.',

    // Charts & Widgets
    'battery.minCellVoltage': 'Tension Cell. Min',
    'battery.maxCellVoltage': 'Tension Cell. Max',

    'battery.mosTemp': 'Temp. MOS',
    'battery.envTemp': 'Temp. Ambiante',
    'battery.otherTemps': 'Autres Temp.',

    'battery.noDataAvailable': 'Aucune donnée disponible',
    'battery.fetchError': 'Échec récupération historique',
    'battery.generalError': 'Une erreur s\'est produite',

    // Settings - Common
    'settings.recover': 'Récupérer',
    'settings.delay': 'Délai',
    'settings.unitV': 'Unité : V',
    'settings.unitA': 'Unité : A',
    'settings.unitMs': 'Unité : ms',
    'settings.unitUs': 'Unité : μs',
    'settings.unitC': 'Unité : °C',
    'settings.charge': 'Charge',
    'settings.discharge': 'Décharge',
    'settings.high': 'Haut',
    'settings.low': 'Bas',
    'settings.description': 'Description',
    'settings.read': 'Lire',
    'settings.setting': 'Paramétrage...',
    'settings.readSuccess': 'Lecture réussie',
    'settings.timeout': 'Délai d\'attente dépassé',
    'settings.operationFailed': 'Opération échouée',
    'settings.failed': 'Échec',
    'settings.jkReadOnlyNote': 'Les paramètres du JK BMS sont mis à jour automatiquement par diffusion et sont en lecture seule dans ce système.',
    'settings.lastUpdated': 'Dernière mise à jour',
    'settings.chargeHighTemp': 'Temp. de charge élevée',
    'settings.dischargeHighTemp': 'Temp. de décharge élevée',
    'settings.designCapacity': 'Capacité nominale',
    'settings.balanceMaxCurrent': 'Courant d\'équilibre max',
    'settings.balanceTriggerDiff': 'Diff. d\'équilibre',

    // Settings - Control Tab
    'settings.mosControl': 'Contrôle MOS',
    'settings.chargeMosControl': 'Contrôle MOS Charge',
    'settings.openChargeMos': 'Ouvrir MOS Charge',
    'settings.closeChargeMos': 'Fermer MOS Charge',
    'settings.dischargeMosControl': 'Contrôle MOS Décharge',
    'settings.openDischargeMos': 'Ouvrir MOS Décharge',
    'settings.closeDischargeMos': 'Fermer MOS Décharge',
    'settings.powerManagement': 'Gestion Puissance',
    'settings.shutdownSleep': 'Arrêt/Veille',
    'settings.opening': 'Ouverture...',
    'settings.closing': 'Fermeture...',
    'settings.executing': 'Exécution...',

    // Settings - Protection Tab
    'settings.protGroup1': 'Paramètres Protection Tension',
    'settings.cellOvercharge': 'Surcharge Cellule',
    'settings.cellOverchargeDesc': 'Lorsque la tension de cellule dépasse continuellement la valeur de protection pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge. Après déclenchement, lorsque toutes les tensions de cellules descendent sous la valeur de récupération, le système restaure la fonction de charge.',
    'settings.cellOverdischarge': 'Sous-décharge Cellule',
    'settings.cellOverdischargeDesc': 'Lorsque la tension de cellule descend continuellement sous la valeur de protection pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la décharge. Après déclenchement, lorsque toutes les tensions de cellules remontent au-dessus de la valeur de récupération, le système restaure la fonction de décharge.',
    'settings.totalOvercharge': 'Surcharge Totale',
    'settings.totalOverchargeDesc': 'Lorsque la tension totale dépasse continuellement la valeur de protection pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge. Après déclenchement, lorsque toutes les tensions de cellules descendent sous la valeur de récupération, le système restaure la fonction de charge.',
    'settings.totalOverdischarge': 'Sous-décharge Totale',
    'settings.totalOverdischargeDesc': 'Lorsque la tension totale descend continuellement sous la valeur de protection pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la décharge. Après déclenchement, lorsque toutes les tensions de cellules remontent au-dessus de la valeur de récupération, le système restaure la fonction de décharge.',

    'settings.protGroup2': 'Paramètres Protection Courant',
    'settings.chargeOvercurrent': 'Surcharge Charge',
    'settings.chargeOvercurrentDesc': 'La valeur d\'avertissement est le courant de charge maximum demandé à l\'onduleur. Lorsque le courant de charge dépasse continuellement la valeur de protection pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge.',
    'settings.dischargeOvercurrent1': 'Surcharge Décharge 1',
    'settings.dischargeOvercurrent1Desc': 'La valeur d\'avertissement est le courant de décharge maximum demandé à l\'onduleur. Lorsque le courant de décharge dépasse continuellement la valeur de protection pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la décharge.',
    'settings.dischargeOvercurrent2': 'Surcharge Décharge 2',
    'settings.dischargeOvercurrent2Desc': 'Lorsque le courant de décharge dépasse continuellement la valeur de protection pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la décharge.',
    'settings.maxChargeCurrent': 'Limite Courant Charge',
    'settings.maxChargeCurrentDesc': 'La Limite de Courant de Charge (CCL) désigne le courant de charge maximum autorisé qu\'un seul module batterie rapporte à l\'onduleur en conditions normales. Lorsque N modules sont connectés en parallèle, le courant total maximum demandé par le système batterie à l\'onduleur est la somme des CCL individuels, soit CCL × N. \\nLa valeur de protection désigne le seuil de courant auquel un seul module batterie déclenche la protection de surcharge. Le CCL doit être inférieur à la valeur de protection.',
    'settings.maxDischargeCurrent': 'Limite Courant Décharge',
    'settings.maxDischargeCurrentDesc': 'La Limite de Courant de Décharge (DCL) désigne le courant de décharge maximum autorisé qu\'un seul module batterie rapporte à l\'onduleur en conditions normales. Lorsque N modules sont connectés en parallèle, le courant total maximum demandé par le système batterie à l\'onduleur est la somme des DCL individuels, soit DCL × N. \\nLa valeur de protection désigne le seuil de courant auquel un seul module batterie déclenche la protection de surcharge. Le DCL doit être inférieur à la valeur de protection.',
    'settings.maxChargeVoltage': 'Limite Tension Charge',
    'settings.maxChargeVoltageDesc': 'La Limite de Tension de Charge (CVL) est la tension totale maximum demandée par le système batterie à l\'onduleur.',
    'settings.chargeVoltageLimitV': 'CVL (V)',
    'settings.chargeCurrentLimitA': 'CCL (A)',
    'settings.dischargeCurrentLimitA': 'DCL (A)',
    'settings.shortCircuitDesc': 'Lorsqu\'un court-circuit est détecté pendant le délai défini, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge et la décharge.',

    'settings.protGroup3': 'Paramètres Protection Température',
    'settings.tempHigh': 'Protection Température Haute',
    'settings.tempHighDesc': 'Lorsque la température dépasse la valeur de protection, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge ou la décharge. Après déclenchement, lorsque la température descend sous la valeur de récupération, le système restaure la fonction de charge ou de décharge.',
    'settings.tempLow': 'Protection Température Basse',
    'settings.tempLowDesc': 'Lorsque la température descend sous la valeur de protection, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge ou la décharge. Après déclenchement, lorsque la température remonte au-dessus de la valeur de récupération, le système restaure la fonction de charge ou de décharge. Lorsque la température descend sous la valeur d\'avertissement de charge, la fonction de chauffage s\'active automatiquement. Lorsque la température remonte à la valeur de récupération de charge, la fonction de chauffage s\'éteint automatiquement.',
    'settings.mosTempHigh': 'Protection Température MOS Haute',
    'settings.mosTempHighDesc': 'Lorsque la température MOS est supérieure à la valeur de protection, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge et la décharge. Après déclenchement, lorsque la température MOS descend sous la valeur de récupération, le système restaure la fonction de charge ou de décharge.',
    'settings.envTemp': 'Protection Température Ambiante',
    'settings.envTempDesc': 'Lorsque la température ambiante dépasse la valeur de protection haute ou descend sous la valeur de protection basse, le BMS exécute immédiatement l\'action de protection et arrête forcément la charge ou la décharge. Après déclenchement, lorsque la température ambiante revient dans la plage de récupération correspondante, le système restaure automatiquement la fonction de charge ou de décharge.',

    'settings.enableProtection': 'Activer Protection',
    'settings.chargeTempProt': 'Protection Temp. Charge',
    'settings.dischargeTempProt': 'Protection Temp. Décharge',

    // Settings - History Tab
    'settings.historyManagement': 'Gestion Registres Historique',
    'settings.reading': 'Lecture...',
    'settings.readHistory': 'Lire tous les registres (1-40)',
    'settings.stopReading': 'Arrêter Lecture',
    'settings.clearHistory': 'Effacer Registres',
    'settings.messages.historyReadComplete': 'Lecture registres terminée ! Total {{count}} registres lus',
    'settings.historyRecords': 'Registres ({{count}})',
    'settings.record': 'Registre {{index}}',
    'settings.timeUnknown': 'Heure Inconnue',
    'settings.cellInfo': 'Infos Cellules ({{count}})',
    'settings.tempSensors': 'Capteurs Temp. ({{count}})',
    'settings.statusInfo': 'Infos État',
    'settings.noHistoryFound': 'Aucun registre trouvé',
    'settings.clearHistoryResult': 'Résultat effacement registres',
    'settings.confirmClearHistory': 'Confirmer Effacement',
    'settings.confirmClearHistoryDesc': 'Voulez-vous vraiment supprimer tous les registres historique du BMS ?',
    'settings.clearHistoryWarning': 'Cette opération supprimera définitivement toutes les données de registres du BMS et ne pourra pas être récupérée.',
    'settings.confirmDelete': 'Confirmer Suppression',

    // Settings - Protocol Tab
    'settings.inverterProtocolConfig': 'Configuration Protocole Onduleur',
    'settings.protocolSelectDesc': 'Après lecture de la liste des protocoles, sélectionnez celui que vous utilisez dans le menu déroulant.',

    'settings.canProtocol': 'Protocole CAN',
    'settings.rs485Protocol': 'Protocole RS485',
    'settings.selectCanProtocol': 'Sélectionner Prot. CAN',
    'settings.selectRs485Protocol': 'Sélectionner Prot. RS485',

    // Settings - System Tab
    'settings.mainBatterySettings': 'Paramètres Pack Maître',
    'settings.systemConfig': 'Configuration Batterie',
    'settings.otherConfig': 'Autres Paramètres',
    'settings.timeSettings': 'Paramètres Heure',
    'settings.timeSettingsDesc': 'Heure interne BMS, utilisée pour l\'affichage et l\'enregistrement des données. La synchronisation avec l\'heure locale facilite le suivi des données.',
    'settings.syncTime': 'Synchroniser Heure Locale',
    'settings.bmsTime': 'Heure BMS',
    'settings.capacitySettings': 'Paramètres Capacité',
    'settings.capacitySettingsDesc': 'La modification des paramètres de capacité restante affecte l\'affichage du pourcentage SOC. La capacité nominale est la capacité de la batterie à sa fabrication, et la capacité totale de charge indique la capacité actuelle réelle de la batterie, qui diminue avec le temps d\'utilisation et le nombre de cycles.',
    'settings.batterySeries': 'Paramètres Série',
    'settings.batterySeriesDesc': 'Le nombre de cellules en série par défaut du système est 16. Lorsque le nombre réel est inférieur à 16, ajustez-le ici à la valeur correspondante.',
    'settings.batterySeriesHelper': 'Nombre cellules en série',
    'settings.cycleCount': 'Paramètres Cycles',
    'settings.cycleCountDesc': 'Le compteur de cycles s\'incrémente automatiquement pendant le processus de charge/décharge, et peut être ajusté manuellement ici.',
    'settings.cycleCountHelper': 'Nombre cycles charge/décharge',
    'settings.fullChargeParams': 'Paramètres Pleine Charge',
    'settings.fullChargeParamsDesc': 'Définir les conditions de détermination de la pleine charge. Lorsque la tension et le courant de la batterie remplissent simultanément les conditions de coupure, le BMS détermine que la batterie est pleinement chargée. L\'alarme de faible capacité sert à définir le seuil d\'alerte de batterie faible.',
    'settings.fullChargeCutoffVoltage': 'Tension Coupure Pleine Charge (V)',
    'settings.fullChargeCutoffCurrent': 'Courant Coupure Pleine Charge (A)',
    'settings.lowCapacityAlarm': 'Alarme Cap. Basse (%)',
    'settings.capacityRelease': 'Paramètres Libération Capacité',
    'settings.capacityReleaseDesc': 'Définir Commande (Set) : A5\\nDéfinir le seuil SOC pour la libération de capacité.',
    'settings.socValue': 'Valeur SOC (%)',
    'settings.socRange': 'Plage : 74-97',
    'settings.currentZero': 'Calibration Zéro Courant',
    'settings.currentZeroDesc': 'Commande : AA\\nCalibrer le zéro du capteur de courant en l\'absence de courant. Vous pouvez entrer une valeur de correction (par défaut 0).',
    'settings.correctionValue': 'Valeur Correction (0,1A)',
    'settings.refVoltage': 'Calibration Tension Référence',
    'settings.refVoltageDesc': 'Commande : A9\\nCalibrer la tension de référence du pack batterie (généralement la référence d\'échantillonnage de tension cellule). Entrez la valeur de tension réelle mesurée (mV).',
    'settings.actualVoltageMv': 'Tension Réelle (mV)',
    'settings.totalVoltage': 'Calibration Tension Totale',
    'settings.totalVoltageDesc': 'Entrez ici la tension réelle de la batterie mesurée par multimètre ou autre équipement, qui peut servir à calibrer la valeur affichée par le BMS.',
    'settings.actualTotalVoltageMv': 'Tension Totale Réelle (mV)',
    'settings.chargeCurrent': 'Calibration Courant Charge',
    'settings.chargeCurrentDesc': 'Commande : AC\\nCalibrer le courant de charge. Entrez la valeur de courant de charge réelle mesurée (A). Le système convertira automatiquement en unités de 0,1A.',
    'settings.actualCurrentA': 'Courant Réel (A)',
    'settings.dischargeCurrent': 'Calibration Courant Décharge',
    'settings.dischargeCurrentDesc': 'Commande : AB\\nCalibrer le courant de décharge. Entrez la valeur de courant de décharge réelle mesurée (A). Le système convertira automatiquement en unités de 0,1A.',
    'settings.systemInfo': 'Informations Système',
    'settings.versionInfo': 'Informations Version',
    'settings.versionInfoDesc': 'Version firmware BMS.',
    'settings.internalVersion': 'Version Firmware',
    'settings.internalVersionHelper': 'Informations version interne',
    'settings.restoreDefault': 'Restaurer Défaut',
    'settings.restoreDefaultDesc': 'Cette opération restaurera tous les paramètres aux valeurs d\'usine du BMS.',
    'settings.restoreDefaultBtn': 'Restaurer Paramètres Défaut',
    'settings.restoring': 'Restauration...',

    // Settings - Permissions Tab
    'settings.permissionsDesc': 'Accorder à d\'autres utilisateurs la permission de voir ou contrôler cette installation.',
    'settings.shareSuccess': 'Partagé avec {{email}}',
    'settings.shareFailed': 'Échec partage installation',
    'settings.removeAccessSuccess': 'Permission supprimée',
    'settings.removeAccessFailed': 'Échec suppression permission',
    'settings.loadingUsers': 'Chargement utilisateurs...',
    'settings.noSharedUsers': 'Aucun utilisateur n\'a encore accès.',
    'settings.noPermission': 'Vous n\'avez pas la permission de gérer cette installation. Seul le propriétaire peut la partager.',
    'settings.userEmail': 'Email Utilisateur',
    'settings.accessLevel': 'Niveau d\'Accès',
    'settings.readOnly': 'Lecture Seule',
    'settings.readWrite': 'Lecture/Écriture',
    'settings.sharing': 'Partage...',
    'settings.shareDevice': 'Partager Installation',
    'settings.usersWithAccess': 'Utilisateurs Avec Accès',
    'settings.remove': 'Supprimer',

    // Settings - SettingsLogTab
    'settings.modificationLog': 'Registre Modifications',
    'settings.loadHistoryFailed': 'Échec chargement registres',
    'settings.noChangesFound': 'Aucune modification trouvée',
    'settings.logSetting': 'Paramètre',
    'settings.na': 'N/A',

    // Settings - Params Mapping (Log Types)
    'settings.enabled': 'Activé',
    'settings.controlMode': 'Mode Contrôle',
    'settings.delayMs': 'Délai (ms)',
    'settings.unknown': 'Inconnu',
    'settings.alarmVoltage': 'Alarme (mV)',
    'settings.chargeAlarmVoltage': 'Alarme Charge (mV)',
    'settings.dischargeAlarmVoltage': 'Alarme Décharge (mV)',
    'settings.protectionVoltage': 'Protection (mV)',
    'settings.recoveryVoltage': 'Récupération (mV)',
    'settings.alarmVoltageV': 'Alarme (V)',
    'settings.protectionVoltageV': 'Protection (V)',
    'settings.recoveryVoltageV': 'Récupération (V)',
    'settings.alarmCurrentA': 'Alarme (A)',
    'settings.protectionCurrentA': 'Protection (A)',
    'settings.recoveryCurrentA': 'Récupération (A)',
    'settings.chargeProtectionCurrentA': 'Protection Charge (A)',
    'settings.delayUs': 'Délai (μs)',
    'settings.alarmCurrentMa': 'Alarme (mA)',
    'settings.protectionCurrentMa': 'Protection (mA)',
    'settings.recoveryCurrentMa': 'Récupération (mA)',
    'settings.alarmTemp': 'Alarme (°C)',
    'settings.protectionTemp': 'Protection (°C)',
    'settings.recoveryTemp': 'Récupération (°C)',
    'settings.chargeHighTempAlarm': 'Alarme Temp. Haute Charge (°C)',
    'settings.chargeHighTempProtection': 'Protection Temp. Haute Charge (°C)',
    'settings.chargeHighTempRecovery': 'Récupération Temp. Haute Charge (°C)',
    'settings.dischargeHighTempAlarm': 'Alarme Temp. Haute Décharge (°C)',
    'settings.dischargeHighTempProtection': 'Protection Temp. Haute Décharge (°C)',
    'settings.dischargeHighTempRecovery': 'Récupération Temp. Haute Décharge (°C)',
    'settings.chargeLowTempAlarm': 'Alarme Temp. Basse Charge (°C)',
    'settings.chargeLowTempProtection': 'Protection Temp. Basse Charge (°C)',
    'settings.chargeLowTempRecovery': 'Récupération Temp. Basse Charge (°C)',
    'settings.dischargeLowTempAlarm': 'Alarme Temp. Basse Décharge (°C)',
    'settings.dischargeLowTempProtection': 'Protection Temp. Basse Décharge (°C)',
    'settings.dischargeLowTempRecovery': 'Récupération Temp. Basse Décharge (°C)',
    'settings.envHighTempAlarm': 'Alarme Temp. Haute Amb. (°C)',
    'settings.envHighTempProtection': 'Protection Temp. Haute Amb. (°C)',
    'settings.envHighTempRecovery': 'Récupération Temp. Haute Amb. (°C)',
    'settings.envLowTempAlarm': 'Alarme Temp. Basse Amb. (°C)',
    'settings.envLowTempProtection': 'Protection Temp. Basse Amb. (°C)',
    'settings.envLowTempRecovery': 'Récupération Temp. Basse Amb. (°C)',
    'settings.socPercent': 'SOC (%)',
    'settings.sleepVoltageMv': 'Tension Veille (mV)',
    'settings.sleepDelayMin': 'Délai Veille (min)',
    'settings.chargeDelayMs': 'Délai Charge (ms)',
    'settings.chargeProtectionCurrentMa': 'Courant Protection Charge (mA)',
    'settings.dischargeDelayMs': 'Délai Décharge (ms)',

    // Balance Settings
    'settings.balance': 'Paramètres Équilibrage Actif',
    'settings.balanceDesc': 'Définir la tension de démarrage pour l\'équilibrage actif. L\'équilibrage s\'active lorsque la tension de cellule est supérieure à la tension de démarrage, et s\'éteint lorsqu\'elle est inférieure.',
    'settings.balanceStartVoltage': 'Tension Démarrage',
    'settings.balanceStartDiff': 'Diff. Démarrage',
    'settings.balanceStartVoltageMv': 'Tension Démarrage (mV)',
    'settings.balanceStartDiffMv': 'Diff. Démarrage (mV)',

    // JK BMS Paramètres - Protection tension pack
    'jk.noSettingsData': 'Aucune donnée de paramétrage reçue. Les paramètres sont mis à jour lorsque le BMS diffuse une trame SETUP.',
    'jk.chargeVoltages': 'Tensions de Charge',
    'jk.socSettings': 'Paramètres SOC',
    'jk.packVoltageProtection': 'Protection tension pack',
    'jk.packOVP': 'Tension de Flottaison',
    'jk.packUVP': 'Tension Max de Charge de l\'Onduleur',
    'jk.floatVoltage': 'Tension de Flottaison',
    'jk.inverterMaxChargeVoltage': 'Tension Max de Charge de l\'Onduleur',
    'jk.soc100Voltage': 'Tension SOC 100%',
    'jk.soc0Voltage': 'Tension SOC 0%',
    'jk.smartSleepVoltage': 'Tension veille intelligente',
    'jk.autoPowerOffVoltage': 'Tension arrêt auto.',
    // JK BMS Paramètres - Protection courant
    'jk.currentProtection': 'Protection courant',
    'jk.chargeOC': 'Limite courant de charge',
    'jk.chargeOCPDelay': 'Délai OCP charge',
    'jk.chargeOCPRelease': 'Libération OCP charge',
    'jk.dischargeOC': 'Limite courant de décharge',
    'jk.dischargeOCPDelay': 'Délai OCP décharge',
    'jk.dischargeOCPRelease': 'Libération OCP décharge',
    'jk.scpRelease': 'Libération SCP',
    // JK BMS Paramètres - Configuration batterie
    'jk.batteryConfig': 'Configuration batterie',
    'jk.cellCount': 'Nombre de cellules',
    'jk.chargeSwitch': 'Interrupteur charge',
    'jk.dischargeSwitch': 'Interrupteur décharge',
    'jk.balanceSwitch': 'Interrupteur équilibrage',
    'jk.scpDelay': 'Délai SCP',
    // JK BMS Paramètres - Configuration appareil
    'jk.deviceConfig': 'Configuration appareil',
    'jk.deviceAddress': 'Adresse appareil',
    'jk.prechargeDelay': 'Délai précharge',
    'jk.smartSleepTime': 'Temps veille intelligente',
    'jk.heatEnabled': 'Chauffage',
    'jk.tempSensorDisabled': 'Capteur temp. désactivé',
    'jk.gpsHeartbeat': 'Heartbeat GPS',
    'jk.portSwitch': 'Port (RS485)',
    'jk.lcdAlwaysOn': 'LCD toujours allumé',
    'jk.specialCharger': 'Chargeur spécial',
    'jk.smartSleepEnabled': 'Veille intelligente',
    'jk.disablePCLModule': 'Désact. module PCL',
    'jk.timedStoredData': 'Stockage données planifié',
    'jk.chargingFloatMode': 'Mode charge flottante',

    // Setting Types
    'settings.fullCharge': 'Paramètres Pleine Charge',
    'settings.cellSleep': 'Veille Cellule',
    'settings.cellSleepDesc': 'Lorsque la tension de cellule descend sous la tension de veille pendant plus longtemps que le délai, la batterie entre en mode veille pour économiser l\'énergie.',
    'settings.inverterProtocol': 'Protocole Onduleur',

    // InstallationSettings Main Page
    'settings.title': 'Paramètres Installation',

    'settings.sendCommandFailed': 'Échec envoi commande',
    'settings.confirmShutdown': 'Confirmer Arrêt/Veille',
    'settings.confirmShutdownDesc': 'Voulez-vous vraiment arrêter ou mettre la batterie en veille ? Après l\'arrêt, vous devrez vous rendre sur site pour démarrer manuellement.',

    // Tabs
    'settings.tabs.control': 'Contrôle',
    'settings.tabs.protection': 'Protections',
    'settings.tabs.protocol': 'Protocoles',
    'settings.tabs.system': 'Système',
    'settings.tabs.log': 'Registre',

    // Messages
    'settings.messages.fetchingProtocolSettings': 'Récupération paramètres protocole...',
    'settings.messages.fetchProtocolListFailed': 'Échec récupération liste protocoles',
    'settings.messages.fetchingHistory': 'Lecture registres historique...',
    'settings.messages.startReadingHistory': 'Début lecture registres...',
    'settings.messages.readingHistoryProgress': 'Lecture registre {{current}}/{{total}}...',
    'settings.messages.protocolSetSuccess': 'Protocole défini avec succès',
    'settings.messages.protocolListSuccess': 'Liste protocoles récupérée',
    'settings.messages.protocolListComplete': 'Récupération terminée ! {{count}} protocoles trouvés',
    'settings.messages.protocolListCompleteCan': 'Récupération terminée ! {{count}} protocoles CAN trouvés',
    'settings.messages.fetchingProtocolIds': 'Récupération IDs protocoles...',
    'settings.messages.fetchingCanNames': 'Récupération noms CAN...',
    'settings.messages.fetchingRs485Names': 'Récupération noms RS485...',

    // Support System
    'support.title': 'Support Technique',
    'support.newPost': 'Nouveau Post',
    'support.editPost': 'Modifier Post',
    'support.searchPlaceholder': 'Rechercher posts...',
    'support.filterByTag': 'Filtrer par Tag',
    'support.allTags': 'Tous Tags',
    'support.products': 'Produits',
    'support.categories': 'Catégories',
    'support.sortBy': 'Trier Par',
    'support.sortLatest': 'Plus Récent',
    'support.sortPopular': 'Populaire',
    'support.sortUnsolved': 'Non Résolu',
    'support.sortMostViewed': 'Plus Vus',
    'support.loadError': 'Échec chargement posts',
    'support.noSearchResults': 'Aucun post trouvé',
    'support.noPosts': 'Aucun post encore',
    'support.createFirstPost': 'Créer premier post',
    'support.minutesAgo': 'il y a {{count}} min',
    'support.hoursAgo': 'il y a {{count}} h',
    'support.daysAgo': 'il y a {{count}} j',
    'support.pinned': 'Épinglé',
    'support.locked': 'Verrouillé',
    'support.resolved': 'Résolu',
    'support.private': 'Privé',
    'support.views': 'Vues',
    'support.replies': 'Réponses',
    'support.noReplies': 'Aucune réponse',
    'support.backToList': 'Retour Liste',
    'support.postNotFound': 'Post introuvable',
    'support.accessDenied': 'Accès refusé',
    'support.addReply': 'Ajouter Réponse',
    'support.replyPlaceholder': 'Entrez votre réponse...',
    'support.submitReply': 'Envoyer Réponse',
    'support.loginToReply': 'Connectez-vous pour répondre',
    'support.postLocked': 'Post verrouillé, impossible de répondre',
    'support.bestAnswer': 'Meilleure Réponse',
    'support.markBestAnswer': 'Marquer Meilleure Réponse',
    'support.unmarkBestAnswer': 'Démarquer',
    'support.confirmDelete': 'Confirmer Suppression',
    'support.confirmDeletePost': 'Supprimer ce post ?',
    'support.confirmDeleteReply': 'Supprimer cette réponse ?',
    'support.pin': 'Épingler',
    'support.unpin': 'Désépingler',
    'support.lock': 'Verrouiller',
    'support.unlock': 'Déverrouiller',
    'support.statusOpen': 'Non Résolu',
    'support.statusResolved': 'Résolu',
    'support.statusClosed': 'Fermé',
    'support.postTitle': 'Titre Post',
    'support.titlePlaceholder': 'Décrivez brièvement votre problème',
    'support.postContent': 'Contenu',
    'support.contentPlaceholder': 'Décrivez en détail votre problème ou suggestion...',
    'support.selectProduct': 'Sélectionner Produit',
    'support.noProduct': 'Aucun',
    'support.selectCategory': 'Sélectionner Catégorie',
    'support.categoryRequired': 'Veuillez sélectionner une catégorie',
    'support.announcementAdminOnly': 'Seuls les admins peuvent publier des annonces',
    'support.titleContentRequired': 'Titre et contenu obligatoires',
    'support.linkDevice': 'Lier Appareil',
    'support.linkDeviceDescription': 'Liez un appareil pour partager son état actuel et ses paramètres avec le support.',
    'support.selectDevice': 'Sélectionner Appareil',
    'support.noDevice': 'Aucun',
    'support.packIndex': 'Index Pack Batterie',
    'support.linkedDeviceSnapshot': 'Instantané État Appareil Lié',
    'support.publicPost': 'Post Public',
    'support.privatePost': 'Post Privé',
    'support.publicDescription': 'Tout le monde peut voir ce post',
    'support.privateDescription': 'Seuls vous et les admins pouvez voir ce post',
    'support.submitPost': 'Envoyer Post',
    'support.saveDraft': 'Enregistrer Brouillon',
    'support.draftSaved': 'Brouillon enregistré',
    'support.similarPostsFound': 'Posts similaires trouvés, peut-être déjà répondu :',
    'support.createError': 'Échec création post',

    // Phase 2 additions
    'support.myPosts': 'Mes Posts',
    'support.myPostsTab': 'Mes Posts',
    'support.draftsTab': 'Brouillons',
    'support.noMyPosts': 'Vous n\'avez encore rien publié',
    'support.untitledDraft': 'Brouillon Sans Titre',
    'support.lastSaved': 'Dernier enregistrement',
    'support.continueDraft': 'Continuer Édition',
    'support.deleteDraft': 'Supprimer Brouillon',
    'support.noDrafts': 'Aucun brouillon enregistré',
    'support.addImages': 'Ajouter Images',
    'support.maxFilesError': 'Maximum {{max}} images autorisées',
    'support.onlyImagesAllowed': 'Seuls les fichiers image sont autorisés',
    'support.fileTooLarge': 'Fichier trop volumineux (max 10Mo)',
    'support.uploadFailed': 'Échec téléchargement',
    'common.uploadImages': 'Télécharger Images',

    // Phase 3 additions
    'support.mentioning': 'Mentionne',

    // Phase 4 additions
    'support.adminPanel': 'Gestion Support',
    'support.tagsTab': 'Gestion Tags',
    'support.templatesTab': 'Modèles Réponses',
    'support.reportsTab': 'Gestion Signalements',
    'support.addTag': 'Ajouter Tag',
    'support.editTag': 'Modifier Tag',
    'support.tagType': 'Type Tag',
    'support.tagColor': 'Couleur Tag',
    'support.confirmDeleteTag': 'Supprimer ce tag ?',
    'support.addTemplate': 'Ajouter Modèle',
    'support.editTemplate': 'Modifier Modèle',
    'support.templateContent': 'Contenu Modèle',
    'support.templatePreview': 'Aperçu',
    'support.templatePlaceholder': 'Supporte format Markdown...',
    'support.noTemplates': 'Aucun modèle',
    'support.confirmDeleteTemplate': 'Supprimer ce modèle ?',
    'support.useTemplate': 'Utiliser Modèle',
    'support.loadTemplatesError': 'Échec chargement modèles',
    'support.filterStatus': 'Filtrer Statut',
    'support.reportedContent': 'Contenu Signalé',
    'support.reportReason': 'Raison Signalement',
    'support.reporter': 'Signaleur',
    'support.reportPending': 'En Attente',
    'support.reportReviewed': 'Examiné',
    'support.reportDismissed': 'Rejeté',
    'support.markReviewed': 'Marquer Examiné',
    'support.dismissReport': 'Rejeter Signalement',
    'support.noReports': 'Aucun signalement',

    // API Keys
    'apiKeys.menuTitle': 'Clés API',
    'apiKeys.title': 'Clés API',
    'apiKeys.description': 'Gérer les clés d\'accès pour les intégrations tierces',
    'apiKeys.usageWarning': 'Utilisez les Clés API pour authentifier les applications externes comme Home Assistant ou Grafana sans avoir besoin de vous connecter. Gardez vos clés secrètes !',
    'apiKeys.myKeys': 'Mes Clés',
    'apiKeys.generateKey': 'Générer Clé',
    'apiKeys.keyName': 'Nom',
    'apiKeys.created': 'Créée',
    'apiKeys.lastUsed': 'Dernière Utilisation',
    'apiKeys.noKeys': 'Aucune clé API trouvée',
    'apiKeys.integrationExamples': 'Exemples d\'Intégration',
    'apiKeys.haTitle': 'Home Assistant (Capteur REST)',
    'apiKeys.haInstructions': 'Ajoutez ceci à votre configuration.yaml :',
    'apiKeys.curlTitle': 'cURL / Terminal',
    'apiKeys.generateDialogTitle': 'Générer Clé API',
    'apiKeys.keyNameLabel': 'Nom Clé (ex: Home Assistant)',
    'apiKeys.generateAction': 'Générer',
    'apiKeys.successDialogTitle': 'Clé API Générée',
    'apiKeys.copyWarning': 'Copiez cette clé maintenant. Vous ne pourrez plus la voir !',
    'apiKeys.createError': 'Échec création clé API',
    'apiKeys.deleteError': 'Échec suppression clé',
    'apiKeys.loadError': 'Échec chargement clés API',

    // Paramètres
    'settings.deleteAccount': 'Supprimer le compte',
    'settings.deleteAccountDesc': 'Une fois votre compte supprimé, il n\'y a plus de retour en arrière. S\'il vous plaît soyez certain.',
    'settings.deleteAccountConfirm': 'Êtes-vous sûr de vouloir supprimer votre compte ?',
    'settings.deleteAccountWarning': 'Cette action est permanente et ne peut pas être annulée.',
    'settings.deleteAccountSuccess': 'Compte supprimé avec succès',
  },
  // App specific
};

export default fr;
